'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var react = require('@chakra-ui/react');
var Spinner = require('../../Spinner/Spinner.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Customizes `react-select`'s LoadingIndicator.
 * Check out https://react-select.com/components to read more!
 */
var LoadingIndicator = function LoadingIndicator(props) {
  var children = props.children,
    className = props.className,
    cx = props.cx,
    getStyles = props.getStyles,
    innerProps = props.innerProps;
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), children || /*#__PURE__*/React__default["default"].createElement(Spinner.Spinner, {
    size: "sm",
    color: "gray.200"
  }));
};
exports["default"] = LoadingIndicator;